import { actOnData, getDeep } from './helpers'

export const isSigned = paymentModel =>
  (getDeep(paymentModel, 'signing.signingStatus') ||
    getDeep(paymentModel, 'application.signing.signingStatus')) === 'SIGNED'

export const isApproved = ({ status }) => status === 'APPROVED'

export const SigningTypes = Object.freeze({
  ELECTRONIC: 'ELECTRONIC',
  PHYSICAL: 'PHYSICAL',
  DIGITAL_AGREEMENT: 'DIGITAL_AGREEMENT',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
})

export const getCustomerIdentification = paymentModel =>
  actOnData(
    paymentModel.customer,
    ({ identification: { type, reference } = {} }) => ({
      type,
      reference,
    }),
  )

export const getCoCustomerIdentification = paymentModel =>
  actOnData(
    paymentModel.coCustomer,
    ({ identification: { type, reference } = {} }) => ({
      type,
      reference,
    }),
  )

export const isIdentified = paymentModel => {
  return (
    !actOnData(
      getCustomerIdentification(paymentModel),
      ({ type, reference }) => !type || !reference,
    ) &&
    !actOnData(
      getCoCustomerIdentification(paymentModel),
      ({ type, reference }) => !type || !reference,
    )
  )
}
